module.exports = __webpack_public_path__ + "img/87ne.8f7978fd.svg";